// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DebitCardGetDebitCardDetailDefaultResponse {
    static getAttributeTypeMap() {
        return DebitCardGetDebitCardDetailDefaultResponse.attributeTypeMap;
    }
}
DebitCardGetDebitCardDetailDefaultResponse.discriminator = undefined;
DebitCardGetDebitCardDetailDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "DebitCardInfoResponseModel"
    }
];
//# sourceMappingURL=debitCardGetDebitCardDetailDefaultResponse.js.map